import { useMemo } from 'react'

const useValidationErrorClassName = (isShowError: boolean) => {
  return useMemo(() => {
    return isShowError ? 'validation-error' : undefined
  }, [isShowError])
}

export default useValidationErrorClassName
